import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Chip, mergeSlotProps, useTheme } from '@mui/material';
import { alpha, darken, lighten } from '@mui/material/styles';
import { IconUtils } from '../utils/IconUtils';

export const KrBadge = ({ label, color, icon, sx, variant = 'solid', slotProps = {} }) => {
  const theme = useTheme();
  let baseColor = theme.color(color) ?? theme.palette.text.secondary;

  // On a dark card surface we use an opaque pale tint so the card's color
  // doesn't bleed through and muddy the badge'sz identity.
  const bg = theme.palette.mode === 'dark' ? darken(baseColor, 0.9) : lighten(baseColor, 0.75);
  const fg = theme.palette.mode === 'dark' ? lighten(baseColor, 0.35) : darken(baseColor, 0.35);

  return (
    <Chip
      label={label}
      icon={
        icon && (
          <FontAwesomeIcon
            {...mergeSlotProps(slotProps?.icon, {
              spin: (icon.iconName || icon).includes('spinner'),
              pull: 'left',
              color: fg,
              style: {
                fontSize: '14px',
              },
              fixedWidth: true,
            })}
            icon={IconUtils.iconFromIconStr(icon)}
          />
        )
      }
      size="small"
      variant={variant}
      sx={{
        ...mergeSlotProps(sx, {
          backgroundColor: bg,
          color: fg,
          WebkitTextFillColor: fg,
          fontSize: '0.7rem',
          fontWeight: 'bold',
          letterSpacing: '0.04em',
          textTransform: 'uppercase',
          whiteSpace: 'nowrap',
          borderRadius: '8px',
          border: theme.palette.mode === 'dark' ? `1px solid ${alpha(fg, 0.4)}` : undefined,
        }),
      }}
    ></Chip>
  );
};
